module.exports = __webpack_public_path__ + "img/ico-instagram.abe89e4e.svg";